// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__Oxctj","consentsList":"PatientConsents_consentsList__1HVK-","consentsListEmpty":"PatientConsents_consentsListEmpty__19gbv"};